class KlaviyoSubscribeForm extends HTMLElement {
  constructor() {
    super();

    this.translateData = this.querySelector('#klaviyo-translate');
    this.form = this.querySelector('.klaviyo-subscribe-form__form');
  }

  connectedCallback() {
    this.observeMutationsOnce(this.form);
  }

  translateForm(formTag) {
    const translateJson = this.translateData ? JSON.parse(this.translateData.textContent) : false;
    if (!translateJson) return;

    const formTitle = formTag.querySelector(".contact__title.main-title span");
    const formButton = formTag.querySelector("button");
    const formEmail = formTag.querySelector("#email_01JACY9W62M2EWHK02PXZH3YVH");
    const formFirstName = formTag.querySelector("#first_name_01JACY9W5PX4RXK8CXQ9JK70Q3");
    const formLastName = formTag.querySelector("#last_name_01JACY9W5W43MSR8Y4QR57GEBD");
    const { title, firstName, lastName, email, button } = translateJson;

    if (formButton && button) formButton.textContent = button;
    if (formEmail && email) formEmail.placeholder = email;
    if (formFirstName && firstName) formFirstName.placeholder = firstName;
    if (formLastName && lastName) formLastName.placeholder = lastName;
    if (formTitle && title) formTitle.textContent = title;
}


  observeMutationsOnce(targetNode) {
    if (!targetNode) return;
    const observer = new MutationObserver((mutationsList, observer) => {
      const {target} = mutationsList[0];
      this.translateForm(target);
      observer.disconnect();
    });

    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
  }
}

if (!customElements.get('klaviyo-subscribe-form')) {
  customElements.define('klaviyo-subscribe-form', KlaviyoSubscribeForm);
}